module.exports = __webpack_public_path__ + "static/media/minus.1a566908.svg";